(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-related-products]');

  roots.forEach(function (root) {
    if (root.dataset.loaded) return;

    var load = function () {
      root.dataset.loaded = 'true';
      fetch(root.dataset.url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-related-products]');
          if (fresh && fresh.innerHTML.trim().length) {
            root.innerHTML = fresh.innerHTML;
          } else {
            root.style.display = 'none';
          }
        })
        .catch(function () {
          root.style.display = 'none';
        });
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          observer.disconnect();
          load();
        }
      }, { rootMargin: '400px 0px' });
      observer.observe(root);
    } else {
      load();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
